export default __webpack_public_path__ + "static/media/stocks.ad92388e.svg";